import { render, staticRenderFns } from "./MessageCreate.vue?vue&type=template&id=afb1bef2&"
import script from "./MessageCreate.vue?vue&type=script&lang=js&"
export * from "./MessageCreate.vue?vue&type=script&lang=js&"
import style0 from "./MessageCreate.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports